export default __webpack_public_path__ + "static/media/Walking in diagonal.fd5b0861.jpg";